import featureFlags, { FEATURE_FLAGS } from '../../../utils/featureFlags';

// The best option is to use the RFI record's virtual folder URN, if it doesn't exist we will use PJM virtual folder URN (photosFolderUrn).
export const getTargetVirtualFolderUrn = (recordFolderUrn, photosFolderUrn) => {
  let target;
  if (featureFlags.get(FEATURE_FLAGS.RFIS_USE_THE_RFI_VIRTUAL_FOLDER_URN)) {
    target = recordFolderUrn || photosFolderUrn;
  } else {
    target = photosFolderUrn;
  }

  return target;
};
